import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './header_logo_title.module.scss';

export const HeaderLogoTitle: FC = () => (
  <span className={styles.logoTitle}>
    <FormattedMessage id="header/logo/HeaderLogoTitle.tsx/1" />
  </span>
);
